<div *ngFor="let item of pricing" class="multi-price" [ngClass]="{'multi-breakeven' : displayArrow}">
  <span class="multi-price_name">{{ item.name }}:<span class="status status-{{item.markUpType === 3 ? 'Amount' : item.markUpType === 2 ? 'Margin' : 'Markup'}}" 
    *ngIf="item.name =='Markup'">{{item.markUpType === 3 ? 'Amount' : item.markUpType === 2 ? 'Margin' : 'Markup'}}</span> </span>
  <span class="multi-price_price">{{ item.price }} <i *ngIf="item.isMappedPriceAuto" class="fas fa-check-circle"></i></span>
  <span
    *ngIf="item.isManual !== undefined && item.price !== 'Not set'"
    class="multi-price_icon"
  >
    <span
      *ngIf="item.isManual"
      [matTooltip]="'Price was set by user, not by system'"
      >M</span
    >
  </span>
</div>
<div  *ngIf="displayArrow" class="item item--clickable" (click)="openExpandDialog($event)" >
  <i class="fas fa-chevron-down"></i>
</div>
